import { useWizard } from 'react-use-wizard';
import { useState } from 'react';
function FashionTypeStep({ items = [], value, handleChangeFashionType }) {
   const { previousStep, nextStep } = useWizard();
   const [modalData, setModal] = useState(null);

   const selectFashionType = type => {
      handleChangeFashionType(type);
   };
   const handleShowModal = text => {
      document.body.classList.add('hidden');
      setModal(text);
   };
   const handleCloseModal = () => {
      document.body.classList.remove('hidden');
      setModal(null);
   };
   return (
      <div className="step">
         <div className="step__container">
            <div className="step__content">
               <div className="step__hint">Оберіть фасон</div>
               <div className="step__fashion-types">
                  {items.map(item => (
                     <div key={item.id} className="step__fashion-type-wrap">
                        <div className="step__fashion-type-block">
                           <img
                              src={item.image}
                              alt={item.name}
                              className={`step__fashion-type ${value && value.id === item.id ? 'selected' : ''}`}
                              onClick={() => selectFashionType(item)}
                           />
                           <p>{item.name}</p>
                           <div className="step__tooltip">{item.description}</div>
                        </div>

                        <div className="step__mobile-tooltip-block" onClick={() => handleShowModal(item.description)}>
                           <svg
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 fillRule="evenodd"
                                 clipRule="evenodd"
                                 d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM6.60156 4.20901C6.60156 4.68765 6.96974 5.03128 7.49747 5.03128C8.03747 5.03128 8.4302 4.68765 8.4302 4.20901C8.4302 3.7181 8.03747 3.37447 7.49747 3.37447C6.96974 3.37447 6.60156 3.7181 6.60156 4.20901ZM6.73656 5.89038V12.2722H8.25838V5.89038H6.73656Z"
                                 fill="#161617"
                              />
                           </svg>
                           <p>більше про {item.name} фасон</p>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </div>
         {modalData && (
            <div>
               <div className="step__modal">
                  <p>{modalData}</p>
               </div>
               <div className="step__modal-overlay" onClick={handleCloseModal}></div>
            </div>
         )}

         <div className="step__navigation">
            <button className="step__navigation-item" onClick={() => previousStep()}>
               назад
            </button>
            <button className="step__navigation-item" disabled={!value || !value.id} onClick={() => nextStep()}>
               далі
            </button>
         </div>
      </div>
   );
}

export default FashionTypeStep;
